import { render, staticRenderFns } from "./HeroRabbit.vue?vue&type=template&id=879db2d0&scoped=true"
import script from "./HeroRabbit.vue?vue&type=script&lang=js"
export * from "./HeroRabbit.vue?vue&type=script&lang=js"
import style0 from "./HeroRabbit.vue?vue&type=style&index=0&id=879db2d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879db2d0",
  null
  
)

export default component.exports